// Generated file : do not modify
import Owner from '@/extend/classes/Owner';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Relevés de compte
export class BankDay {
  // Date du relevé
  public dateReleve: Date;
  // Nombre d'écriture'
  public nbEcritures: number;
  // Crédit
  public credit: number;
  // Débit
  public debit: number;
  // Nombre de rapprochements
  public nbRapprochements: number;
  // Nombre de forçages
  public nbForcages: number;

  constructor() {
    this.dateReleve = new Date(1901,1,1,0,0,0,0);
    this.nbEcritures = 0;
    this.credit = 0;
    this.debit = 0;
    this.nbRapprochements = 0;
    this.nbForcages = 0;
  }
}

export class BankMatching {
  // Nombre
  public count: number;
  // Données
  public bankLogs: BankLog[];

  constructor() {
    this.count = 0;
    this.bankLogs = [];
  }
}

export class BankQuery {
  // Montant recherché
  public montant: number;
  // Nombre de transactions sélectionnées
  public count: number;
  // Date si 1 transaction sélectionnée
  public after: Date;
  // Référence si 1 transaction sélectionnée
  public reference: string;
  // Date recherchée
  public date: string;
  // Label recherché
  public label: string;
  // Non pointées
  public notPointed: boolean;

  constructor() {
    this.montant = 0;
    this.count = 0;
    this.after = new Date(1901,1,1,0,0,0,0);
    this.reference = '';
    this.date = '';
    this.label = '';
    this.notPointed = false;
  }
}

export default class BankLog  {
  // Identifiant unique
  public id: number;
  // Date du relevé
  public dateReleve: Date;
  // Date opération
  public dateOperation: Date;
  // Date de valeur
  public dateValeur: Date;
  // Référence banque
  public bankId: number;
  // Montant
  public montant: number;
  // Intitulé
  public label: string;
  // Pièce
  public piece: string;
  // ligne
  public ligne: number;
  // Code externe
  public code: string;
  // Mandat pour rejet prélèvements
  public mandat: string;
  // Rapprochement
  public rapprochement: Owner;
  // Ecriture manuelle
  public manual: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Type
  public rapprochementType: number;
  // Identifiant
  public rapprochementId: number;
  // Nom
  public rapprochementLabel: string;

  constructor() {
    this.id = 0;
    this.dateReleve = new Date(1901,1,1,0,0,0,0);
    this.dateOperation = new Date(1901,1,1,0,0,0,0);
    this.dateValeur = new Date(1901,1,1,0,0,0,0);
    this.bankId = 0;
    this.montant = 0;
    this.label = '';
    this.piece = '';
    this.ligne = 0;
    this.code = '';
    this.mandat = '';
    this.rapprochement = new Owner();
    this.manual = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
    this.rapprochementType = 0;
    this.rapprochementId = 0;
    this.rapprochementLabel = '';
  }

  public static fromJson (obj: BankLog): BankLog {
    const newBankLog: BankLog = new BankLog();
    newBankLog.id = obj.id;
    newBankLog.dateReleve = new Date(obj.dateReleve);
    newBankLog.dateOperation = new Date(obj.dateOperation);
    newBankLog.dateValeur = new Date(obj.dateValeur);
    newBankLog.bankId = obj.bankId;
    newBankLog.montant = obj.montant;
    newBankLog.label = obj.label;
    newBankLog.piece = obj.piece;
    newBankLog.ligne = obj.ligne;
    newBankLog.code = obj.code;
    newBankLog.mandat = obj.mandat;
    newBankLog.rapprochement = JSON.parse(JSON.stringify(obj.rapprochement));
    newBankLog.manual = obj.manual;
    newBankLog.canUpdate = obj.canUpdate;
    newBankLog.canDelete = obj.canDelete;
    newBankLog.display = obj.display;
    newBankLog.notifDefType = obj.notifDefType;
    newBankLog.rapprochementType = obj.rapprochementType;
    newBankLog.rapprochementId = obj.rapprochementId;
    newBankLog.rapprochementLabel = obj.rapprochementLabel;
    return newBankLog;
  }

  public toJsonBankLog (): string {
    const json = {
      dateReleve: this.dateReleve ? new Date (this.dateReleve).toString() : this.dateReleve,
      dateOperation: this.dateOperation ? new Date (this.dateOperation).toString() : this.dateOperation,
      dateValeur: this.dateValeur ? new Date (this.dateValeur).toString() : this.dateValeur,
      bankId: this.bankId,
      montant: this.montant,
      label: this.label,
      piece: this.piece,
      ligne: this.ligne,
      code: this.code,
      mandat: this.mandat,
      rapprochement: this.rapprochement,
      manual: this.manual,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromBankLog (obj: BankLog): void {
    this.id = obj.id;
    this.dateReleve = new Date(obj.dateReleve);
    this.dateOperation = new Date(obj.dateOperation);
    this.dateValeur = new Date(obj.dateValeur);
    this.bankId = obj.bankId;
    this.montant = obj.montant;
    this.label = obj.label;
    this.piece = obj.piece;
    this.ligne = obj.ligne;
    this.code = obj.code;
    this.mandat = obj.mandat;
    this.rapprochement = obj.rapprochement;
    this.manual = obj.manual;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
    this.rapprochementType = obj.rapprochementType;
    this.rapprochementId = obj.rapprochementId;
    this.rapprochementLabel = obj.rapprochementLabel;
  }

  public compareBankLog (value: BankLog): boolean {
    return (this.toJsonBankLog() == value.toJsonBankLog());
  }

  public cloneBankLog (): BankLog {
    return BankLog.fromJson(this);
  }

  public static ListByDay (): Promise<BankDay[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/banklogs/ListByDay', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: BankDay[] = [];
              res.data.forEach(( a: BankDay ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static DayDetails (bankDay: BankDay): Promise<BankLog[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/banklogs/DayDetails', bankDay, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: BankLog[] = [];
              res.data.forEach(( a: BankLog ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static LoadDay (bankDay: BankDay): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/banklogs/LoadDay', bankDay, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static LoadMatching (bankQuery: BankQuery): Promise<BankMatching> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/banklogs/LoadMatching', bankQuery, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(bankLogs: BankLog[]) {
    bankLogs.forEach((item) => {
      item.dateReleve = item.dateReleve ? new Date(item.dateReleve) : item.dateReleve;
      item.dateOperation = item.dateOperation ? new Date(item.dateOperation) : item.dateOperation;
      item.dateValeur = item.dateValeur ? new Date(item.dateValeur) : item.dateValeur;
    })
  }
}
